import React from 'react';
import { Form, Button, InputNumber, Spin } from 'antd';
import { formatCurrency } from 'utils';
import { useTranslation } from 'react-i18next';

import Modal from 'components/antdCustom/Modal';

const layout = {
  labelCol: { sm: { span: 24 }, md: { span: 8 } },
  wrapperCol: { sm: { span: 24 }, md: { span: 8 } },
};

const InputAmount = (props) => {
  const { onChangeAmount, onGenerateQrCode, amount, loading } = props;
  const { t } = useTranslation();

  function handleGenerateQrCode() {
    Modal.confirm({
      title: t('confirmGenerateQrCode')(formatCurrency(amount)),
      onOk: onGenerateQrCode,
      width: 'max-content',
    });
  }

  return (
    <Spin spinning={loading}>
      <Form
        {...layout}
        size='large'
        name='basic'
        onFinish={handleGenerateQrCode}
        loading={loading}>
        <Form.Item
          label={t('coinDepositAmount')}
          name='amountRM'
          rules={[
            {
              required: true,
              message: `${t('pleaseInputAmountRM')}`,
            },
          ]}>
          <InputNumber
            style={{ width: '100%' }}
            addonBefore='RM'
            formatter={formatCurrency}
            onChange={onChangeAmount}
            value={amount}
            name='amountQR'
          />
        </Form.Item>
        <Button type='primary' htmlType='submit'>
          {t('generateQrCode')}
        </Button>
      </Form>
    </Spin>
  );
};

export default InputAmount;
